var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.uniqueKey,staticClass:"rich-text",style:(_vm.richRootInlineStyle)},[_c('div',{ref:"editable",staticClass:"rich-text-block",style:(_vm.richTextEditableStyle),attrs:{"id":"editable"}}),(_vm.options.disableEditing || _vm.isIndicatorReadonly)?_c('div',{staticClass:"editable-mask",on:{"dblclick":_vm.handleDoubleClick}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }